const reportErrorCodes = {
  TOO_EXTENSIVE_OUTPUT: 'RSERR0',
  TIMEOUT: 'RSERR1',
  TOO_EXTENSIVE_COMPUTE: 'RSERR2',
  INTERNAL_SERVER_ERROR: 'RSERR3',
} as const;

export type ReportErrorCode = (typeof reportErrorCodes)[keyof typeof reportErrorCodes];

export const reportErrorCodeDescriptions: Record<ReportErrorCode, string> = {
  [reportErrorCodes.TOO_EXTENSIVE_OUTPUT]: 'The report could not be generated because the selected input parameters require computing too much information. Please adjust the input parameters to reduce the compute scope and try again.',
  [reportErrorCodes.TIMEOUT]: 'The report could not be generated because the selected input parameters require processing that takes too long and the generation timed out. Please adjust the input parameters to reduce the compute scope and try again.',
  [reportErrorCodes.TOO_EXTENSIVE_COMPUTE]: 'The report could not be generated because the selected input parameters produce an output that is too large. Please adjust the input parameters to reduce the report output and try again.',
  [reportErrorCodes.INTERNAL_SERVER_ERROR]: 'The report failed due to an unexpected error. Please retry or contact the Pingwire support',
};

export default reportErrorCodes;
